"use client"

import { Image } from "@/app/components/image"
import { Trans } from "@lingui/react/macro"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@rarible_int/anaconda_ui_components"

/**
 * Temporary links to redirect to OG (a.k.a old) rarible marketplace for Aptos
 *
 * Since, aptos has ongoing agreement with Rarible, we need to redirect to the old marketplace
 * until the end of the contract.
 */

export function AptosTabItem() {
  return (
    <a
      href="https://og.rarible.com/explore/aptos/collections"
      target="_blank"
      rel="noreferrer"
      className="px-3 pb-4 opacity-60 hover:opacity-100"
    >
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="relative h-5 w-5">
            <Image imageSrc="/images/blockchains/aptos.svg" alt="Aptos icon" />
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <Trans>Aptos</Trans>
        </TooltipContent>
      </Tooltip>
    </a>
  )
}

export function AptosSelectItem() {
  return (
    <a
      href="https://og.rarible.com/explore/aptos/collections"
      target="_blank"
      rel="noreferrer"
      className="flex w-full cursor-pointer select-none items-center rounded-sm py-1.5 pr-8 pl-2 text-sm hover:bg-accent hover:text-accent-foreground"
    >
      <div className="flex items-center gap-2">
        <div className="relative h-5 w-5">
          <Image imageSrc="/images/blockchains/aptos.svg" alt="Aptos icon" />
        </div>
        <div className="flex items-center gap-2 overflow-hidden whitespace-nowrap">
          <Trans>Aptos</Trans>
        </div>
      </div>
    </a>
  )
}
